import React from 'react';

import { cn } from '../../lib/utils';
import { useConversation } from './ConversationContext';
import type { Suggestion } from './types';

export interface ConversationSuggestionsProps {
  items: Suggestion[];
  className?: string;
}

export const ConversationSuggestions = ({ items, className }: ConversationSuggestionsProps) => {
  const { callbacks } = useConversation();

  if (items.length === 0) return null;

  return (
    <div className={cn('flex flex-wrap justify-end gap-2 px-4 py-2', className)}>
      {items.map((suggestion) => (
        <button
          key={suggestion.id}
          type="button"
          className="rounded-full border border-border px-4 py-2 text-sm text-foreground hover:bg-muted transition-colors"
          onClick={() => callbacks.onSuggestionClick?.(suggestion)}
        >
          {suggestion.text}
        </button>
      ))}
    </div>
  );
};
